<div class="bar" style="color: white">
  <ion-row class="height-100">
    <ion-col class="ion-no-padding align-item align-item__left 5 height-100">
      <monorepo-zf-icon
        *ngIf="isMobileView"
        class="zf-padding-l-xxl-m"
        [iconClasses]="['zf-icon--margin-none']"
        [iconName]="'ham'"
        (click)="toggleOrgHierachy()"
        style="cursor: pointer"
      >
      </monorepo-zf-icon>
      <monorepo-zf-icon
        [iconName]="'solvei8-logo'"
        [iconClasses]="logoClasses"
        class="zf-padding-l-xxl-3 zf-padding-t-xxl-3"
      ></monorepo-zf-icon>
      <span
        [ngClass]="{'separator': !isMobileView}"
        class="zf-text-s zf-padding-l-xxl-3 zf-padding-r-xxl-3 zf-text-bold"
      >
        Operational<br />
        intelligence</span
      >

      <ng-container *ngIf="selectedHeaderInfo$ | async as headerInfo">
        <zf-button
          *ngIf="headerInfo.shifts && headerInfo.shifts.length > 1"
          [buttonClasses]="['shift-selector-box']"
          [buttonType]="'primary'"
          (clickEvent)="shiftSelectorClick()"
          [state]="headerInfo.activeTab !== 'ANALYTICS' ? 'disabled' : 'default'"
        >
          <div class="shift-wrapper">
            <span class="zf-text-s zf-text-normal" style="display: block">
              <span>{{shiftDisplayName}}</span>
              <i *ngIf="shiftList.length > 1" class="arrow-r"></i>
            </span>
          </div>
        </zf-button>
      </ng-container>
    </ion-col>
    <ng-container *ngIf="selectedHeaderInfo$ | async as headerInfo">
      <ng-container>
        <ion-col class="ion-no-padding align-item align-item__right height-100">
          <div class="nav-item-wrapper" *ngIf="!isMobileView">
            <ng-container *ngFor="let navItem of headerInfo.navigationTabs">
              <ng-container [ngSwitch]="navItem">
                <button
                  *ngSwitchCase="'MM_ANALYTICS_CHATBOT'"
                  class="header-link header-background ai-analytics-header-icon"
                  (click)="openAiAnalytics()"
                >
                  <monorepo-zf-icon
                    [iconName]="'chatbot-ai-select'"
                    [iconClasses]="iconClassesLarge"
                  ></monorepo-zf-icon>
                  <span class="zf-text-xs zf-text-white zf-text-normal">{{"aiAnalytics.ChatbotAi" | translate}}</span>
                </button>
                <button
                  *ngSwitchCase="'ANALYTICS'"
                  class="header-link header-background"
                  [ngClass]="{'activeNav': headerInfo.activeTab === 'ANALYTICS'}"
                  (click)="openPage({ route: '/page-analytics/redirect' })"
                >
                  <monorepo-zf-icon [iconName]="'analytics'" [iconClasses]="iconClassesLarge"></monorepo-zf-icon>
                  <span class="zf-text-xs zf-text-white zf-text-normal">Analytics</span>
                </button>

                <button
                  *ngSwitchCase="'REPORTS'"
                  class="header-link header-background"
                  [ngClass]="{'activeNav': headerInfo.activeTab === 'REPORTS'}"
                  (click)="openPage({ route: '/page-reports' })"
                >
                  <monorepo-zf-icon [iconName]="'reports'" [iconClasses]="iconClassesLarge"></monorepo-zf-icon>
                  <span class="zf-text-xs zf-text-white zf-text-normal">Reports</span>
                </button>
                <button
                  *ngSwitchCase="'ORDERS_DASHBOARD'"
                  class="header-link header-background"
                  [ngClass]="{'activeNav': headerInfo.activeTab === 'ORDERS_DASHBOARD'}"
                  (click)="openPage({ route: '/page-orders' })"
                >
                  <monorepo-zf-icon [iconName]="'orders'" [iconClasses]="iconClassesLarge"></monorepo-zf-icon>
                  <span class="zf-text-xs zf-text-white zf-text-normal">Orders</span>
                </button>
                <button
                  *ngSwitchCase="'MM_ANALYTICS'"
                  class="header-link header-background"
                  [ngClass]="{'activeNav': headerInfo.activeTab === 'MM_ANALYTICS'}"
                  (click)="openPage({ route: '/page-mm-analytics/redirect' })"
                >
                  <monorepo-zf-icon [iconName]="'analytics'" [iconClasses]="iconClassesLarge"></monorepo-zf-icon>
                  <span class="zf-text-xs zf-text-white zf-text-normal">MM Analytics</span>
                </button>
                <button
                  *ngSwitchCase="'SKILLI8_ANALYTICS'"
                  class="header-link header-background"
                  [ngClass]="{'activeNav': headerInfo.activeTab === 'SKILLI8_ANALYTICS'}"
                  (click)="openPage({ route: '/page-skilli8-analytics/redirect' })"
                >
                  <monorepo-zf-icon [iconName]="'analytics'" [iconClasses]="iconClassesLarge"></monorepo-zf-icon>
                  <span class="zf-text-xs zf-text-white zf-text-normal">Skilli8 Analytics</span>
                </button>

                <div
                  class="plani8-reports-tab"
                  *ngSwitchCase="'REPORTS_V2'"
                  [ngClass]="{'activeNav': headerInfo.activeTab === 'REPORTS_V2'}"
                  (click)="openPage({ route: '/reports-v2' })"
                >
                  <monorepo-zf-icon [iconName]="'reports'" [iconClasses]="iconClassesLarge"></monorepo-zf-icon>
                  Plani8 Reports
                </div>
              </ng-container>
            </ng-container>
            <button class="header-link header-background" (click)="presentPopover($event, headerInfo.language)">
              <monorepo-zf-icon [iconName]="'settings'" [iconClasses]="iconClassesLarge"> </monorepo-zf-icon>
              <span class="zf-text-xs zf-text-white zf-text-normal">Settings</span>
            </button>
          </div>
          <div [ngClass]="{'separator-l': !isMobileView}" class="align-items zf-padding-l-xxl-3 zf-padding-r-xxl-3">
            <span class="zf-text-xs">{{currentTime().format('ddd, DD MMM')}}</span>
            <br />
            <span class="zf-text-xs">{{currentTime().format('hh:mm A')}}</span>
            <monorepo-zf-icon
              *ngIf="onLine"
              [iconName]="'online-indicator'"
              [iconClasses]="iconClassesSmall"
            ></monorepo-zf-icon>
          </div>
        </ion-col>
      </ng-container>
    </ng-container>
  </ion-row>
</div>
